import React from "react";
import {
    Button,
    TextField,
    MenuItem,
    Select,
    FormControl,
    InputLabel,
    Box,
    FormControlLabel,
    Checkbox,
    CircularProgress,
    makeStyles
} from "@material-ui/core";
import { Save, Delete, Edit } from "@material-ui/icons";

const useStyles = makeStyles(theme => ({
    main: {
        maxWidth: "100%",
        margin: "40px auto",
        borderRadius: "20px",
        border: "1px solid #00000050",
        background: "#fff"
    },
    heading: {
        fontSize: "1.25rem",
        fontWeight: "bold",
        marginBottom: "1rem",
        maxWidth: "1000px",
        margin: "auto",
        textAlign: "center"
    },
    errMsg: { color: "red", fontFamily: "Roboto", lineHeight: "40px", maxWidth: "1000px", margin: "auto" },
    questionBox: {
        maxWidth: "1000px",
        margin: "auto",
        rowGap: "6px",
        marginBottom: "10px",
        columnGap: "10px",
        "&>div": {
            columnGap: "15px"
        }
    },
    buttons: {
        display: "flex",
        maxWidth: "1000px",
        margin: "40px auto 20px auto",
        justifyContent: "space-between"
    },
    questionText: {
        maxWidth: "100%",
        width: "100%",
        "& fieldset": {
            borderWidth: "0 0 1px 0 !important",
            borderRadius: "0"
        },
        "& input": {
            minHeight: "40px",
            padding: "10px 10px 5px !important"
        }
    },
    select: {
        width: "150px",
        maxWidth: "150px",
        "& fieldset": {
            borderWidth: "0 0 1px 0 !important",
            borderRadius: "0"
        }
    },
    editBtn: {
        position: "relative",
        borderRadius: "6px",
        background: "#4D5CCC",
        padding: "5px",
        color: "#fff",
        minWidth: "40px !important",
        "& span": {
            display: "flex !important",
            justifyContent: "center !important",
            alignItems: "center !important",
            margin: "0 !important"
        },
        "&:hover": {
            background: "#4D5CCC"
        },
        "&:hover div": {
            display: "flex"
        }
    },
    deleteBtn: {
        position: "relative",
        minWidth: "40px !important",
        maxWidth: "40px !important",
        backgroundColor: "#d11507 !important",
        "& span": {
            display: "flex !important",
            justifyContent: "center !important",
            alignItems: "center !important",
            margin: "0 !important"
        },
        "&:hover div": {
            display: "flex"
        }
    },
    questionBoxField: {
        display: "flex",
        alignItems: "center",
        width: "100%",
        gap: "20px",
        "& input": {
            width: "24px",
            height: "24px",
            borderRadius: "5px",
            background: "#F0F0F0"
        },
        "& p": {
            // borderBottom: "1px solid #00000020",
            padding: "8px 0",
            display: "flex",
            justifyContent: "space-between",
            columnGap: "10px"
        }
    },
    questionFieldName: {
        borderBottom: "1px solid #00000020",
        flex: "1 0 auto"
    },
    questionFieldRequired: {
        color: "red",
        width: "78px",
        borderBottom: "1px solid #00000020"
    },
    questionFieldType: {
        // borderBottom: "1px solid #00000020"
        display: "flex",
        columnGap: "10px",
        width: "190px"
    },
    fieldTypeLabel: {
        borderBottom: "1px solid #00000020",
        width: "115px"
    },
    addButton: {
        color: "#343434",
        border: "1px dashed #343434",
        background: " #FFF",
        boxShadow: "none !important",
        "&:hover": {
            background: " #FFF !important"
        }
    },

    toolTip: {
        position: "absolute",
        top: "-50px",
        left: "-75%",
        background: "#F0F0F0",
        border: "1px solid #00000030",
        minWidth: "100px",
        height: "45px",
        borderRadius: "8px",
        justifyContent: "center",
        alignItems: "center",
        display: "none",
        color: "#000",
        "&::before": {
            content: "''",
            position: "absolute",
            top: "100%",
            left: "50%",
            transform: "translateX(-50%)",
            borderStyle: "solid",
            borderWidth: " 6px 7px 0px 7px",
            borderColor: "#00000080 transparent transparent"
        }
    },
    typeHeader: {
        width: "115px",
        // textAlign: "end"
    },
    actionHeader: {
        width: "90px",
        // textAlign: "end"
    },
    requiredHeader: {
        width: "78px",
        // textAlign: "end"
    },
    questionHeader: {
        fontWeight: "bold"
    },
    nameHeader: {
        flex: "1 0 auto"
    },
    questionHeaderBox: {
        display: "flex",
        alignItems: "center",
        gap: "20px",
        marginBottom: "10px"
    },

    "@media (max-width:680px) ": {
        main: {
            padding: "40px 16px"
        }
    },
    "@media (max-width:600px) ": {
        questionBoxField: {
            "& p": {
                flexDirection: "column"
            }
        }
    }
}));

const CustomQuestion = props => {
    const classes = useStyles();
    const {
        addQuestion,
        questions,
        handleChange,
        saveQuestion,
        removeQuestion,
        selectedIds,
        handleCheckboxChange,
        editQuestion,
        err,
        sendMail,
        errors,
        handleUpdateQuestion,
        setShowDeleteModal,
        setDeleteId,
        loadingStates,
        loading
    } = props;
    return (
        <Box className={classes.main} p={5}>
            <h2 className={classes.heading}>Brugerdefinerede spørgsmål</h2>

            {errors &&
                Object.values(errors).map((msg, index) => (
                    <p className={classes.errMsg} key={index}>
                        {msg}
                    </p>
                ))}
            <Box className={classes.buttons}>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={addQuestion}
                    className={classes.addButton}
                    // style={{ background: "#4D5CCC" }}
                >
                    + Tilføj spørgsmål
                </Button>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={sendMail}
                    style={{ background: "#4D5CCC" }}
                    disabled={loading}>
                    Sende Mail {loading && <CircularProgress size={24} />}
                </Button>
            </Box>
            {/* New Questions Form */}
            <Box className={classes.questionBox}>
                {/* 👇 HEADER ADDED HERE */}
                <Box className={classes.questionHeaderBox}>
                    <Box className={`${classes.questionHeader} `} style={{ width: "24px" }} />
                    <Box className={`${classes.questionHeader} ${classes.nameHeader} `}> Spørgsmåls navn </Box>
                    <Box className={`${classes.questionHeader} ${classes.typeHeader}`}>Spørgsmåls type</Box>
                    <Box className={`${classes.questionHeader} ${classes.requiredHeader}`}>Er påkrævet</Box>
                    <Box className={`${classes.questionHeader} ${classes.actionHeader}`}>Handlinger</Box>
                </Box>
                {questions.map(question => {
                    return (
                        <Box key={question.id} display="flex" alignItems="center" gap={2}>
                            {question.isEditing || question.isSave ? (
                                <>
                                    <TextField
                                        className={classes.questionText}
                                        label={question.isEditing ? "" : "Spørgsmåls navn"}
                                        variant="outlined"
                                        value={question.fieldName}
                                        onChange={e => handleChange(question.id, "fieldName", e.target.value)}
                                        error={Boolean(err[question.id])} // Show error state
                                        helperText={err[question.id]} // Display error message below field
                                    />
                                    {!question.isEditing && (
                                        <FormControl variant="outlined" className={classes.select}>
                                            <InputLabel>Type</InputLabel>
                                            <Select
                                                value={question.fieldType}
                                                onChange={e => handleChange(question.id, "fieldType", e.target.value)}
                                                label="Type">
                                                <MenuItem value="text">Tekst</MenuItem>
                                                <MenuItem value="number">Antal</MenuItem>
                                                <MenuItem value="checkbox">Afkrydsningsfelt</MenuItem>
                                            </Select>
                                        </FormControl>
                                    )}
                                    {!question.isEditing && (
                                        <FormControlLabel
                                            style={{ width: "100px", margin: "0" }}
                                            control={
                                                <Checkbox
                                                    style={{ padding: "2px" }}
                                                    checked={question.isRequired}
                                                    onChange={e =>
                                                        handleChange(question.id, "isRequired", e.target.checked)
                                                    }
                                                    color="primary"
                                                />
                                            }
                                            label="Påkrævet"
                                        />
                                    )}
                                    <div style={{ display: "flex", columnGap: "15px" }}>
                                        <Button
                                            className={classes.editBtn}
                                            variant="contained"
                                            color="primary"
                                            onClick={() => {
                                                if (question.isEditing) {
                                                    handleUpdateQuestion(
                                                        question.id,
                                                        question.fieldName,
                                                        question.fieldType,
                                                        question.isRequired
                                                    );
                                                } else {
                                                    saveQuestion(
                                                        question.id,
                                                        question.fieldName,
                                                        question.fieldType,
                                                        question.isRequired
                                                    );
                                                }
                                            }}
                                            startIcon={
                                                loadingStates[question.id] ? (
                                                    <CircularProgress size={24} color="inherit" />
                                                ) : (
                                                    <Save />
                                                )
                                            }
                                            disabled={loadingStates[question.id]} // Disable only for the specific question
                                        >
                                            <div className={classes.toolTip}>
                                                <span>Save</span>
                                            </div>
                                            {/* {loadingStates[question.id] ? "Saving..." : "Save"} */}
                                        </Button>
                                        <Button
                                            className={classes.deleteBtn}
                                            variant="contained"
                                            color="secondary"
                                            onClick={() => removeQuestion(question.id)}
                                            startIcon={<Delete />}>
                                            <div className={classes.toolTip}>
                                                <span>Delete</span>
                                            </div>
                                        </Button>
                                    </div>
                                    {/* {!question.isEditing && ( */}

                                    {/* )} */}
                                </>
                            ) : (
                                <>
                                    <div className={classes.questionBoxField} key={question.id}>
                                        <input
                                            type="checkbox"
                                            checked={selectedIds.includes(question.id)}
                                            onChange={() => handleCheckboxChange(question.id)}
                                        />
                                        <div style={{ maxWidth: "100%", width: "100%" }}>
                                            {/* <p
                                            // style={{ display: "flex", justifyContent: "space-between" }}
                                            >
                                                <span> {question.fieldName} </span>
                                                <span>
                                                    ({question.fieldType}){question.isRequired ? "*Påkrævet" : ""}
                                                </span>
                                            </p> */}
                                            <p>
                                                <span className={classes.questionFieldName}>{question.fieldName}</span>
                                                <span className={classes.questionFieldType}>
                                                    <span className={classes.fieldTypeLabel}>
                                                        ({question.fieldType === "text" && "Tekst"}
                                                        {question.fieldType === "number" && "Antal"}
                                                        {question.fieldType === "checkbox" && "Afkrydsningsfelt"})
                                                    </span>

                                                    {/* {question.isRequired ? " *Påkrævet" : ""} */}
                                                    {question.isRequired ? (
                                                        <span
                                                            className={classes.questionFieldRequired}
                                                            style={{ color: "red" }}>
                                                            {" "}
                                                            *Påkrævet
                                                        </span>
                                                    ) : (
                                                        ""
                                                    )}
                                                </span>
                                            </p>
                                        </div>
                                        <div style={{ display: "flex", columnGap: "15px" }}>
                                            <Button
                                                className={classes.editBtn}
                                                type="button"
                                                variant="contained"
                                                color="default"
                                                onClick={() => editQuestion(question.id)}
                                                startIcon={<Edit />}>
                                                <div className={classes.toolTip}>
                                                    <span>Edit</span>
                                                </div>
                                            </Button>
                                            <Button
                                                className={classes.deleteBtn}
                                                variant="contained"
                                                color="secondary"
                                                onClick={() => {
                                                    setDeleteId(question.id);
                                                    setShowDeleteModal(true);
                                                }}
                                                startIcon={<Delete />}>
                                                <div className={classes.toolTip}>
                                                    <span>Delete</span>
                                                </div>
                                            </Button>
                                        </div>
                                    </div>
                                </>
                            )}
                        </Box>
                    );
                })}
            </Box>
        </Box>
    );
};

export default CustomQuestion;
